export default "__VITE_ASSET__CNZb7Amv__"